import { assign, createMachine, InterpreterFrom, sendParent } from 'xstate'
import type { Size } from '../types'

type UnsetContext = { size: undefined }
type SetContext = { size: Size }
type ProductContext = { size?: Size }

type ProductTypestate =
  | {
      value: 'unset'
      context: UnsetContext
    }
  | {
      value: 'set'
      context: SetContext
    }

type SetEvent = {
  type: 'SET'
  size: Size
}
type UnsetEvent = {
  type: 'UNSET'
}
export type ProductEvent = SetEvent | UnsetEvent

export const productMachine = createMachine<
  ProductContext,
  ProductEvent,
  ProductTypestate
>({
  id: 'product',
  initial: 'unset',
  context: { size: undefined },

  on: {
    SET: {
      target: 'set',
      actions: [
        assign({
          size: (context, event) => event.size,
        }),
        sendParent((_context, { size }) => ({
          type: 'SET_PRODUCT',
          product: { size },
        })),
      ],
    },
  },

  states: {
    unset: {},

    set: {
      on: {
        UNSET: {
          target: 'unset',
          actions: [
            assign({
              size: () => undefined,
            }),
            sendParent(() => ({
              type: 'SET_PRODUCT',
              product: undefined,
            })),
          ],
        },
      },
    },
  },
  predictableActionArguments: true,
})

export type ProductInterpreter = InterpreterFrom<typeof productMachine>
